import React from "react";
import PropTypes from "prop-types";
import { Box, Button, Typography, Grid } from "@mui/material";
import DeleteIcon from "@mui/icons-material/Delete";
import { GridToolbar } from "@mui/x-data-grid";
import Table from "../../common/Table";
import Loading from "../../Loading";

//#region Styling
const sx = {
    '.MuiTablePagination-displayedRows, .MuiTablePagination-selectLabel': {
        marginTop: '1em',
        marginBottom: '1em'
    },
    '.MuiDataGrid-columnHeaders': {
        backgroundColor: 'rgb(242, 243, 244)',
    },
    '& .MuiDataGrid-columnHeaderTitle': {
        fontWeight: 'bold',
    },
};
//#endregion

const SettingsExclusionView = ({
    // Props
    title,
    columns,
    renderInputForm,
    onClose,
    datagridProps = {},
    // Hook
    isLoading,
    items,
    paginationModel,
    setPaginationModel,
    selectedRowIds,
    handleSelectionChange,
    handleRemoveSelected,
    handleSave,
}) => {
    return (
        <>
            <Box sx={{ p: 2 }}>
                <Typography variant="h6" sx={{ mb: 2 }}>
                    {title} Settings
                </Typography>

                {/* Render the specific input form passed from the parent */}
                {renderInputForm()}

                {/* Table listing items */}
                <Box sx={{ height: 400, width: "100%", mb: 2 }}>
                    <Table
                        data={items}
                        columns={columns}
                        pagination
                        rowsPerPageOptions={[10, 25, 50]}
                        paginationModel={paginationModel}
                        onPaginationModelChange={setPaginationModel}
                        getRowId={(row) => row.id}
                        checkboxSelection
                        onRowSelectionModelChange={handleSelectionChange}
                        rowSelectionModel={selectedRowIds}
                        rowHeight={60}
                        columnHeaderHeight={80}
                        slots={{ toolbar: GridToolbar }}
                        slotProps={{
                            toolbar: {
                                showQuickFilter: true,
                                csvOptions: { disableToolbarButton: true },
                                printOptions: { disableToolbarButton: true },
                            }
                        }}
                        sx={sx}
                        disableColumnFilter
                        disableColumnSelector
                        disableDensitySelector
                        {...datagridProps}
                    />
                </Box>

                {/* Action buttons: Remove, Cancel, Save */}
                <Grid container spacing={2}>
                    <Grid item container justifyContent="flex-end">
                        <Button
                            variant="outlined"
                            endIcon={<DeleteIcon />}
                            disabled={selectedRowIds.length === 0}
                            onClick={handleRemoveSelected}
                            className="remove-button"
                        >
                            Remove
                        </Button>
                    </Grid>
                    <Grid item container justifyContent="flex-end" spacing={2} xs>
                        <Grid item>
                            <Button variant="outlined" className="button white small" onClick={onClose}>
                                Cancel
                            </Button>
                        </Grid>
                        <Grid item>
                            <Button variant="contained" color="primary" className="button red small" onClick={handleSave}>
                                Save
                            </Button>
                        </Grid>
                    </Grid>
                </Grid>
            </Box>
            {isLoading && <Loading />}
        </>
    );
};

SettingsExclusionView.propTypes = {
    title: PropTypes.string.isRequired,
    columns: PropTypes.array.isRequired,
    renderInputForm: PropTypes.func.isRequired,
    onClose: PropTypes.func.isRequired,
    isLoading: PropTypes.bool.isRequired,
    items: PropTypes.array.isRequired,
    paginationModel: PropTypes.object.isRequired,
    setPaginationModel: PropTypes.func.isRequired,
    selectedRowIds: PropTypes.array.isRequired,
    handleSelectionChange: PropTypes.func.isRequired,
    handleRemoveSelected: PropTypes.func.isRequired,
    handleSave: PropTypes.func.isRequired,
};

export default SettingsExclusionView;